import { getFamilyByPhone, validatePhoneNumber as mockValidatePhone } from '../data/mockData'
import { apiFetch } from './httpClient'
import { toNational } from './cognitoAuth'

const PHONE_HEADER_NAME = 'X-Phone-Number'
const USE_MOCK_DATA = import.meta.env.VITE_USE_MOCK_DATA === 'true'

// Error strings returned here are translation keys (auth.*) when they are
// ours; a message the backend sends is passed through as-is.
const isSoftMiss = (status) => status === 401 || status === 403 || status === 404

export function isUsingMockData() {
  return USE_MOCK_DATA
}

export function validatePhoneNumber(phone) {
  const cleaned = String(phone || '').replace(/\D/g, '')
  return cleaned.length === 10
}

export async function startLogin(phone, method = 'sms') {
  const cleanPhone = toNational(phone)

  if (USE_MOCK_DATA) {
    const isValid = mockValidatePhone(phone)
    return {
      success: isValid,
      status: isValid ? 200 : 403,
      data: isValid ? { ok: true } : { error: 'auth.invalidPhone' },
    }
  }

  const result = await apiFetch('/login', {
    method: 'POST',
    skipAuth: true,
    headers: {
      [PHONE_HEADER_NAME]: cleanPhone,
      'X-Otp-Method': method === 'call' ? 'call' : 'sms',
    },
    body: JSON.stringify({ phone: cleanPhone }),
  })

  if (!result.ok) {
    return {
      success: false,
      status: result.status,
      data: {
        error:
          result.status === 403
            ? 'auth.phoneNotFound'
            : result.data?.message || result.data?.error || 'auth.sendFailed',
      },
    }
  }

  return { success: true, status: result.status, data: result.data }
}

export async function getFamily(phone) {
  if (USE_MOCK_DATA) {
    const familyData = getFamilyByPhone(phone)
    return {
      success: Boolean(familyData),
      status: familyData ? 200 : 404,
      data: familyData ? { familyData } : { error: 'auth.familyLoadFailed' },
    }
  }

  const result = await apiFetch('/family', { method: 'GET' })
  if (!result.ok) {
    if (isSoftMiss(result.status)) {
      return {
        success: true,
        status: result.status,
        data: { familyData: null },
      }
    }
    return {
      success: false,
      status: result.status,
      data: { error: result.data?.message || 'auth.familyLoadFailed' },
    }
  }

  const familyData = result.data?.data?.family?.[0] || null
  return {
    success: true,
    status: result.status,
    data: { familyData, raw: result.data },
  }
}

export async function getClass() {
  if (USE_MOCK_DATA) {
    return {
      success: true,
      status: 200,
      data: { classes: [] },
    }
  }

  const result = await apiFetch('/class', { method: 'GET' })
  if (!result.ok) {
    if (isSoftMiss(result.status)) {
      return {
        success: true,
        status: result.status,
        data: { classes: [] },
      }
    }
    return {
      success: false,
      status: result.status,
      data: { error: result.data?.message || 'auth.accountLoadFailed' },
    }
  }

  const classes = result.data?.data?.classes || []
  return {
    success: true,
    status: result.status,
    data: { classes, raw: result.data },
  }
}
